<div class="tcl-page db-max-width">
  <header class="tcl-hero">
    <nav class="tcl-crumb" aria-label="Breadcrumb">
      <a routerLink="/" class="tcl-crumb__link">Dashboard</a>
      <span class="tcl-crumb__sep" aria-hidden="true">/</span>
      <span class="tcl-crumb__here">Clients</span>
    </nav>
    <div class="tcl-hero__row">
      <div class="tcl-hero__titles">
        <h1 class="tcl-title">Clients</h1>
      </div>
      <div *ngIf="loading" class="tcl-hero__status" role="status" aria-live="polite">
        <span class="tcl-spinner" aria-hidden="true"></span>
        <span class="tcl-hero__status-text">Updating…</span>
      </div>
    </div>
  </header>

  <section class="tcl-panel" aria-labelledby="tcl-clients-heading">
    <h2 id="tcl-clients-heading" class="visually-hidden">Client list</h2>

    <div *ngIf="loading" class="tcl-progress" aria-hidden="true">
      <div class="tcl-progress__bar"></div>
    </div>

    <div *ngIf="!loading && rows.length === 0" class="tcl-empty">
      <div class="tcl-empty__icon" aria-hidden="true">
        <i class="ri-team-line"></i>
      </div>
      <h3 class="tcl-empty__title">No clients</h3>
      <p class="tcl-empty__text">No members were returned for your trainer roster.</p>
    </div>

    <div *ngIf="rows.length > 0" class="tcl-results" role="list">
      <article
        *ngFor="let row of rows; trackBy: trackRow"
        class="tcl-client-card"
        role="listitem"
        [class.tcl-client-card--inactive]="row.isInactive"
      >
        <div class="tcl-client-card__top">
          <div class="tcl-avatar-ring">
            <img
              class="tcl-avatar"
              [src]="row.avatar"
              alt=""
              width="52"
              height="52"
              (error)="$any($event.target).src = 'assets/images/users/user-dummy-img.jpg'"
            />
          </div>
          <div class="tcl-client-card__identity">
            <h3 class="tcl-client-name">{{ row.name }}</h3>
            <p class="tcl-client-meta">Member ID <span class="tcl-client-meta__id">{{ row.id }}</span></p>
          </div>
          <span *ngIf="row.isInactive" class="tcl-pill tcl-pill--warn">Inactive</span>
        </div>

        <div class="tcl-stat-grid" role="group" [attr.aria-label]="'Session credits for ' + row.name">
          <div
            *ngFor="let s of row.stats"
            class="tcl-stat"
            [class.tcl-stat--group]="s.scope === 'group'"
            [attr.title]="s.title"
          >
            <span class="tcl-stat__cat">{{ s.category }}</span>
            <span class="tcl-stat__dur">{{ s.duration }}</span>
            <span class="tcl-stat__val">{{ s.value }}</span>
            <span class="tcl-stat__unit">sessions</span>
          </div>
        </div>
      </article>
    </div>
  </section>
</div>
